import { render, staticRenderFns } from "./componente-prazopagto.vue?vue&type=template&id=32718fbe"
import script from "./componente-prazopagto.vue?vue&type=script&lang=js"
export * from "./componente-prazopagto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports